import { useEffect } from 'react';

/** Dismisses an artifact selection toolbar on outside interaction or scroll. */
export function useSelectionDismiss(active: boolean, onDismiss: () => void): void {
  useEffect(() => {
    if (!active) return;
    const close = (event: Event): void => {
      const target = event.target;
      if (target instanceof Element && target.closest('[data-selection-toolbar]') !== null) return;
      onDismiss();
    };
    document.addEventListener('pointerdown', close);
    window.addEventListener('scroll', close, true);
    return () => {
      document.removeEventListener('pointerdown', close);
      window.removeEventListener('scroll', close, true);
    };
  }, [active, onDismiss]);
}
